export interface AbsCatalog {
  id?: number;
  name?: string;
  title?: string;
  thumbnail?: string;
  type?: string;
  selected?: boolean;
  catalogs?: Array<Catalog>;
  articles?: Array<Article>;
  advertisings?: Array<Article>;
}

export class Catalog implements AbsCatalog {
  constructor(
    public id?: number,
    public name?: string,
    public title?: string,
    public thumbnail?: string,
    public type?: string,
    public selected?: boolean,
    public catalogs?: Array<Catalog>,
    public articles?: Array<Article>,
    public advertisings?: Array<Article>,
  ) {
      this.id = id || 0;
  }
}